export default __webpack_public_path__ + "static/media/DSCF1032.2b55c069.jpg";